import { render, staticRenderFns } from "./TotpModal.vue?vue&type=template&id=5aa76e7c"
import script from "./TotpModal.vue?vue&type=script&lang=js"
export * from "./TotpModal.vue?vue&type=script&lang=js"
import style0 from "./TotpModal.vue?vue&type=style&index=0&id=5aa76e7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports